import React from 'react';
import Flagship from '../../core/flagship';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import '../../styles/commentBox.scss';
import { Divider, Feed, Form, Table, Loader, Header, Button, Label, Icon, TextArea } from 'semantic-ui-react';

class CommentBox extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.commentKeyUp = this.commentKeyUp.bind(this);
        this.commentChange = this.commentChange.bind(this);
        this.addComment = this.addComment.bind(this);
        this.getComments = this.getComments.bind(this);
        this.resetCommentBox = this.resetCommentBox.bind(this);
    }

    getInitialState() {
        return {
            loading:true,
            commentValue: '',
            commentsShown: 5,
            comments: []
        }
    }

    componentDidMount() {
        this.getComments();
    }

    commentKeyUp(e) {
        if (e.key === "Enter" && e.location === 3) {
            this.addComment(e);
        }
    }

    commentChange(e) {
        this.setState({
            commentValue: e.target.value
        });
    }

    getComments() {

        let self = this;
        Flagship.get(
            'comments/' + this.props.recordId,
            {},
            function (response) {
                if (response.data.success === true) {
                    self.setState({
                        comments: response.data.results,
                        loading:false
                    });

                } else {
                    Flagship.error(
                        "Error getting comments from Flagship API server.",
                        self.props.recordId,
                        self.props.userId
                    );
                }
            },
            function (err) {
                Flagship.error(
                    "Error getting comments from Flagship API server: " + err,
                    self.props.recordId,
                    self.props.userId
                );
            }
        );
    }

    resetCommentBox() {
        this.getComments();
        this.setState({
            commentValue: ''
        });
    }

    addComment() {

        let comment = this.state.commentValue;
        let recordId = this.props.recordId;
        let userId = this.props.userId;
        let resetCommentBox = this.resetCommentBox;

        if ( comment !== null && comment !== "") {
            Flagship.post(
                'comments/new/' + recordId + '/' + userId,
                {comment},
                function (response) {
                    if (response.data.success === true) {
                        Flagship.event('comment', comment, recordId, userId);
                        Flagship.notify("Comment added.", "success");
                        resetCommentBox();
                    }
                    else {
                        Flagship.log("error", "Failed to add comment.", recordId, userId);
                    }
                }
            );
        } else {
            Flagship.notify("Comment box empty.", "info");
        }

    }

    deleteComment(commentId) {

        let getComments = this.getComments;
        let recordId = this.props.recordId;
        let userId = this.props.userId;

        Flagship.post(
            'comments/delete/' + commentId,
            {},
            function(response) {
                if (response.data.success === true) {
                    Flagship.notify("Comment deleted.");
                    getComments();
                } else {
                    Flagship.log(
                        "error",
                        "Failed to delete comment.",
                        recordId,
                        userId
                    );
                }
            }
        );
    }

    viewMoreComments() {
        this.setState({
            commentsShown: Math.max( this.state.commentsShown, this.state.comments.length + 1)
        });
    }

    render() {

        if( typeof this.state.comments === "undefined" || this.state.loading === true ) {
            return (
                <Table>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell colSpan="5">
                                <Loader className="flagship-loader" active inline='centered' >
                                    Loading Comments...
                                </Loader>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            );
        } else {
            let commentsShown = this.state.commentsShown;
            let moreComments = this.state.comments.length - this.state.commentsShown;
            let viewMoreComments = this.viewMoreComments.bind(this);
            let numberComments = this.state.comments.length;
            let deleteComment = this.deleteComment.bind(this);
            let currentUser = this.props.userId;

            return (
                <div className="record-comments">
                    <Divider hidden />
                    <Header as="h3">Comments</Header>
                {moreComments > 0 ?
                    <Divider color="gray" horizontal>
                        <Label onClick={viewMoreComments} className="pointer" title="Click to view more">
                            <Icon name="comment"/>
                            {moreComments}
                            <Label.Detail>Earlier Comment(s)</Label.Detail>
                        </Label>
                    </Divider>
                    : <Divider />}
                    <Feed>
                        {numberComments > 0 ? this.state.comments.map(function(comment, i) {
                            let isCurrentUser = parseInt(comment.user) === currentUser;
                            let commentId = parseInt(comment.id);
                            let photoPath = "someone.png";
                            if ( comment.photo !== null ) {
                                photoPath = comment.photo;
                            }
                            let commenterName = "Someone";
                            if (comment.first_name !== null && comment.last_name !== null ) {
                               commenterName = comment.first_name + " " + comment.last_name;
                            }
                            if (i > numberComments - commentsShown - 1 ) {
                                return (
                                    <Feed.Event key={"comment-" + i} className="single-comment">
                                        {isCurrentUser ?
                                            <Label className="edit-corner-icon"
                                                   size="large"
                                                   corner="right"
                                                   rel={commentId}
                                                   onClick={() => {deleteComment(commentId)} }>
                                                <Icon className="edit-corner-icon-icon" name="trash"/>
                                            </Label>
                                            : null}
                                        <Feed.Label>
                                            <img src={Flagship.config.uploads + photoPath}/>
                                        </Feed.Label>
                                        <Feed.Content>
                                            <Feed.Summary>
                                                <Feed.User>{}</Feed.User>
                                                <span>{commenterName} said:</span>
                                                <Feed.Date>{comment.date}</Feed.Date>
                                            </Feed.Summary>
                                            <Feed.Extra text>
                                                {comment.content}
                                            </Feed.Extra>
                                        </Feed.Content>
                                    </Feed.Event>
                                );
                            }
                        }) : "No comments to display."}
                    </Feed>
                    <Form>
                        <TextArea
                        className="comment-textarea"
                        value={this.state.commentValue}
                        onKeyUp={this.commentKeyUp}
                        onChange={this.commentChange}
                        autoHeight
                        placeholder="Enter your comment..."
                            />
                            <Button
                        onClick={this.addComment}
                        className="add-new-comment">
                            Add New Comment
                        </Button>
                    </Form>
                </div>
            )
        }

    }
}

CommentBox.propTypes = {
    actions: PropTypes.object,
    username: PropTypes.string,
    userId: PropTypes.number
};

function mapStateToProps(state) {
  return {
      username: state.main.username,
      userId: state.main.userId,
  };
}

export default connect(
  mapStateToProps,
  null
)(CommentBox);





// WEBPACK FOOTER //
// ./src/components/records/CommentBox.js